/**
 * Constants copied from auth0-spa-js that are not exported
 */
export const DEFAULT_AUTHORIZE_TIMEOUT_IN_SECONDS = 60;
export const DEFAULT_SILENT_TOKEN_RETRY_COUNT = 3;
export const CLEANUP_IFRAME_TIMEOUT_IN_SECONDS = 2;
export const DEFAULT_FETCH_TIMEOUT_MS = 10000;
export const CACHE_KEY_PREFIX = '@@auth0spajs@@';
export const DEFAULT_AUTH0_CLIENT = {
    name: 'auth0-spa-js',
    version: '1.0.0' // Update this if needed
};
//# sourceMappingURL=constants.js.map